import api from './Api'

// Entorno Grupo: endpoints solo para Administradores de Grupo (siempre dentro de su grupo)
const multipart = { headers: { 'Content-Type': 'multipart/form-data' } }

function importForm (file, dryRun) {
  const form = new FormData()
  form.append('file', file)
  if (dryRun) {
    form.append('dry_run', '1')
  }
  return form
}

export default {
  // 5.1 Administradores de Grupo
  admins: () => api().get('/grupo-admins'),
  createAdmin: payload => api().post('/grupo-admins', payload),
  updateAdmin: (id, payload) => api().put(`/grupo-admins/${id}`, payload),
  setAdminStatus: (id, status) => api().put(`/grupo-admins/${id}/status`, { status }),

  // 5.2 Concesionarios
  dealers: () => api().get('/grupo-dealers'),
  createDealer: payload => api().post('/grupo-dealers', payload),
  updateDealer: (id, payload) => api().put(`/grupo-dealers/${id}`, payload),
  setDealerStatus: (id, status) => api().put(`/grupo-dealers/${id}/status`, { status }),
  enterDealer: id => api().post(`/grupo-dealers/${id}/enter`),

  // 5.3 Partners
  partners: () => api().get('/grupo-partners'),
  createPartner: payload => api().post('/grupo-partners', payload),
  deletePartner: id => api().delete(`/grupo-partners/${id}`),

  // 5.4 Colaboradores
  colaboradores: params => api().get('/grupo-colaboradores', { params }),
  createColaborador: payload => api().post('/grupo-colaboradores', payload),
  updateColaborador: (id, payload) => api().put(`/grupo-colaboradores/${id}`, payload),
  setColaboradorStatus: (id, status) => api().put(`/grupo-colaboradores/${id}/status`, { status }),
  colaboradorUsers: id => api().get(`/grupo-colaboradores/${id}/users`),
  colaboradorLocations: id => api().get(`/grupo-colaboradores/${id}/locations`),

  // 5.5 Usuarios de dealer
  users: params => api().get('/grupo-users', { params }),
  createUser: payload => api().post('/grupo-users', payload),
  updateUser: (id, payload) => api().put(`/grupo-users/${id}`, payload),
  setUserStatus: (id, status) => api().put(`/grupo-users/${id}/status`, { status }),
  userImportTemplate: () => api().get('/grupo-users/import-template', { responseType: 'blob' }),
  importUsers: (file, dryRun = false) => api().post('/grupo-users/import', importForm(file, dryRun), multipart),

  // 5.7 Ubicaciones (el alta y edición van por /locations)
  locationImportTemplate: () => api().get('/grupo-locations/import-template', { responseType: 'blob' }),
  importLocations: (file, dryRun = false) => api().post('/grupo-locations/import', importForm(file, dryRun), multipart),

  // 5.8 Permisos predefinidos por rol
  permissions: () => api().get('/grupo-permissions'),
  setRolePermissions: (role, permissions) => api().put(`/grupo-permissions/${role}`, { permissions })
}
